app.controller("SudoUtilsController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "SudoUtilsService", "ConfirmModal", "Season", "toastr",
    function ($scope, $uibModal, SysParam, StaticData, SudoUtilsService, ConfirmModal, Season, toastr) {
        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);

        SysParam.getSysParam("currentSeason").then(function (param) {
            $scope.param = param;
            $scope.filterSeason = param.value;
        });

        SysParam.getSysParam("managedSeason").then(function (param) {
            $scope.managedSeasonParam = param;
            $scope.managedSeason = param.value;
        });

        SysParam.getSysParam("financialSeason").then(function (param) {
            $scope.financialSeasonParam = param;
            $scope.financialSeason = $scope.fSeason = param.value;
        });

        Season.list()
          .then(function (seasons) {
            $scope.filterSeasons = seasons;
          });

        $scope.recalculateSemesterCredits = function () {
            ConfirmModal.show({
                title: "რეკალკულაცია",
                message: "ნამდვილად გსურთ ამ ოპერაციის შესრულება?"
            }).result.then(function () {
                SudoUtilsService.recalculateSemesterCredits()
                    .then(function (data) {
                        console.log(data);
                    });
            });
        };

        $scope.closeSelections = function() {
            ConfirmModal.show({
                title: "სელექშენების დახურვა",
                message: "ნამდვილად გსურთ ამ ოპერაციის შესრულება?"
            }).result.then(function () {
                SudoUtilsService.closeSelections()
                    .then(function (data) {
                        toastr.success('', 'სელექშენები წარმატებით დაიხურა');
                        console.log(data);
                    });
            });
        };

        $scope.incrementSemesters = function() {
            ConfirmModal.show({
                title: "სემესტრების გაზრდა",
                message: "ნამდვილად გსურთ აქტიურ სტუდენტებზე სემესტრის გაზრდა?"
            }).result.then(function () {
                SudoUtilsService.incrementSemesters()
                    .then(function (data) {
                        toastr.success('', 'სემესტრი წარმატებით გაიზარდა');
                        console.log(data);
                    });
            });
        };

        $scope.$watch('filterSeason', function (val) {
            if ($scope.param && $scope.param._id && val !== $scope.param.value) {
                $scope.param.value = val;
                SysParam.updateSysParam($scope.param)
            }
        }, true);

        $scope.$watch('managedSeason', function (val) {
            if ($scope.managedSeasonParam && $scope.managedSeasonParam._id && val !== $scope.managedSeasonParam.value) {
                $scope.managedSeasonParam.value = val;
                SysParam.updateSysParam($scope.managedSeasonParam)
            }
        }, true);

        $scope.changeFinancialSeason = function () {
            ConfirmModal.show({
                title: "ყურადღება!",
                message: "ფინანსური სეზონის ცვლილება ააქტიურებს სტუდენტებთან ფინანსური გადანაწილების შაბლონების არჩევითობას!"
            }).result.then(function () {
                $scope.financialSeasonParam.value = $scope.financialSeason;
                SysParam.updateSysParam($scope.financialSeasonParam).then(function (res) {
                    toastr.success('', 'ფინანსური სეზონის წარმატებით შეიცვალა');
                });
            }, function () {
                $scope.financialSeason = $scope.fSeason;
            });
        }
    }
]);
